import { FC, lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AppListener } from '../../app/appListener';
import { environment } from '../../environments/environment';
import LoginScreen from '../pages/login/LoginScreen';
import { RootPage } from '../pages/root/RootPage';
import { WelcomeScreen } from '../pages/welcome/WelcomeScreen';

import LazyRoute from './LazyRoute';
import PrivateRoute from './PrivateRoute';

const HomeScreen = lazy(
	() => import(/*webpackChunkName: "Home"*/ '../pages/home/Home')
);
const EmergencyScreen = lazy(() => import('../pages/emergency/Emergency'));

const AppRoutes: FC = () => {
	return (
		<Suspense fallback={null}>
			<BrowserRouter basename={environment.basename}>
				<AppListener />
				<Routes>
					<Route element={<RootPage />}>
						<Route
							path="home/*"
							element={
								<PrivateRoute>
									<LazyRoute>
										<HomeScreen />
									</LazyRoute>
								</PrivateRoute>
							}
						/>

						<Route path="login" element={<LoginScreen />} />

						<Route path="welcome" element={<WelcomeScreen />} />

						<Route
							path="emergency"
							element={
								<PrivateRoute>
									<LazyRoute>
										<EmergencyScreen />
									</LazyRoute>
								</PrivateRoute>
							}
						/>

						<Route path="*" element={<Navigate to="/home" replace />} />
					</Route>
				</Routes>
			</BrowserRouter>
		</Suspense>
	);
};

export default AppRoutes;
